import React from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import NumericInput from 'react-numeric-input';
import { terminalTypeData } from '../shared/constants';

const AirlineDetailsCard = React.memo(function AirlineDetailsCard({
  state,
  errors,
  onChange,
  onAirlineChange,
  onAirlineReturnChange,
  onFlightHourChange,
  onFlightMinuteChange,
  onFlightHourReturnChange,
  onFlightMinuteReturnChange,
  onPaxCountChange,
  onPaxCountReturnChange,
  onTripTypeChange,
  onMeetGreetChange,
  rideTypeId,
}) {
  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-amber" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-amber"><i className="fas fa-plane" /></span>
        <span className="rx-card-title">Airline Details</span>
      </div>
      <div className="rx-card-body">
        {/* Airline + Flight # + Terminal Type + Terminal */}
        <div className="rx-cols-4">
          <div className="rx-fg">
            <label>Airline <span className="req">*</span></label>
            <SelectBox
              dataSource={state.dropdownAirline.length > 0 ? state.dropdownAirline : []}
              placeholder="Select airline"
              name="airlineId"
              defaultValue={0}
              value={state.airlineId}
              displayExpr="airLineName"
              valueExpr="airLineId"
              onSelectionChanged={onAirlineChange}
              showClearButton={true}
              searchEnabled={true}
            />
            {errors.airlineId.length > 0 && <span className="rx-err">{errors.airlineId}</span>}
          </div>
          <div className="rx-fg">
            <label>Flight # <span className="req">*</span></label>
            <input type="text" className="rx-ff" maxLength={25} value={state.flightNumber} onChange={onChange} name="flightNumber" placeholder="Flight #" />
            {errors.flightNumber.length > 0 && <span className="rx-err">{errors.flightNumber}</span>}
          </div>
          <div className="rx-fg">
            <label>Terminal Type</label>
            <select className="rx-ff" name="terminalType" value={state.terminalType} onChange={onChange}>
              <option value="0">Select terminal type</option>
              {terminalTypeData && terminalTypeData.map((item, i) => (
                <option key={i} value={item.id}>{item.name}</option>
              ))}
            </select>
            {errors.terminalType.length > 0 && <span className="rx-err">{errors.terminalType}</span>}
          </div>
          <div className="rx-fg">
            <label>Terminal</label>
            <input type="text" className="rx-ff" maxLength={25} value={state.terminal} onChange={onChange} name="terminal" placeholder="Terminal" />
          </div>
        </div>

        {/* Pilot / Crew / F.A. counts */}
        <div className="rx-cols-3">
          <div className="rx-fg">
            <label>Pilot <span className="req">*</span></label>
            <NumericInput className="form-control form-control-sm" name="pilotCount" title="Pilot Count" value={state.pilotCount} min={0} max={100} onChange={(value) => onPaxCountChange('p', value)} />
            {errors.pilotCount.length > 0 && <span className="rx-err">{errors.pilotCount}</span>}
          </div>
          <div className="rx-fg">
            <label>Crew <span className="req">*</span></label>
            <NumericInput className="form-control form-control-sm" name="crewCount" title="Crew Count" value={state.crewCount} min={0} max={100} onChange={(value) => onPaxCountChange('c', value)} />
          </div>
          <div className="rx-fg">
            <label>F/A <span className="req">*</span></label>
            <NumericInput className="form-control form-control-sm" name="flightAttandCount" title="Flight Attendant Count" value={state.flightAttandCount} min={0} max={100} onChange={(value) => onPaxCountChange('f', value)} />
          </div>
        </div>

        {/* Flight Time hh / min + PO */}
        <div className="rx-cols-3">
          <div className="rx-fg">
            <label>Flight Time [ hh ] <span className="req">*</span></label>
            <SelectBox
              dataSource={state.dropdownHours.length > 0 ? state.dropdownHours : []}
              placeholder="Select Hour"
              name="id"
              defaultValue={0}
              value={state.flightHour}
              displayExpr="name"
              valueExpr="id"
              onSelectionChanged={onFlightHourChange}
              showClearButton={true}
              searchEnabled={true}
            />
            {errors.flightTime.length > 0 && <span className="rx-err">{errors.flightTime}</span>}
          </div>
          <div className="rx-fg">
            <label>[ min ]</label>
            <SelectBox
              dataSource={state.dropdownMinutes.length > 0 ? state.dropdownMinutes : []}
              placeholder="Select Minute"
              name="id"
              defaultValue={0}
              value={state.flightMinute}
              displayExpr="name"
              valueExpr="id"
              onSelectionChanged={onFlightMinuteChange}
              showClearButton={true}
              searchEnabled={true}
            />
          </div>
          <div className="rx-fg">
            <label>PO / Client Ref #</label>
            <input type="text" className="rx-ff" name="poNumber" maxLength="100" title="PO / Client Ref #" value={state.poNumber} onChange={onChange} placeholder="Enter PO / client ref #" />
          </div>
        </div>

        {/* Trip type radios + checkboxes */}
        <div className="rx-check-row">
          <label className="rx-radio-lbl">
            <input type="radio" name="oneWay" value="1" checked={state.tripTypeId === '1'} disabled={state.rideId > 0} onChange={onTripTypeChange} />
            Oneway
          </label>
          <label className="rx-radio-lbl">
            <input type="radio" name="isReturnTrip" value="2" checked={state.tripTypeId === '2'} disabled={state.rideId > 0} onChange={onTripTypeChange} />
            Round Trip
          </label>
          <label className="rx-radio-lbl">
            <input type="radio" name="isRecurring" value="3" checked={state.tripTypeId === '3'} disabled={state.rideId > 0} onChange={onTripTypeChange} />
            Recurring
          </label>
          <label className="rx-chk-lbl">
            <input type="checkbox" checked={state.isVipTrip} onChange={onChange} name="isVipTrip" />
            VIP
          </label>
          <label className="rx-chk-lbl">
            <input type="checkbox" checked={state.isPriorityTrip} onChange={onChange} name="isPriorityTrip" />
            Priority
          </label>
          {(rideTypeId === 1 || rideTypeId === 3) && (
            <label className="rx-chk-lbl">
              <input type="checkbox" checked={state.isMeetGreet} onChange={onMeetGreetChange} name="isMeetGreet" />
              Meet &amp; Greet
            </label>
          )}
        </div>

        {/* Return sub-card (shown when tripTypeId === '2') */}
        {state.tripTypeId === '2' && (
          <div className="rx-sub-card">
            <div className="rx-sub-card-hd">Return Details</div>
            <div className="rx-sub-card-body">
              <div className="rx-cols-2">
                <div className="rx-fg">
                  <label>Airline <span className="req">*</span></label>
                  <SelectBox
                    dataSource={state.dropdownAirline.length > 0 ? state.dropdownAirline : []}
                    placeholder="Select airline"
                    name="airlineIdReturn"
                    defaultValue={0}
                    value={state.airlineIdReturn}
                    displayExpr="airLineName"
                    valueExpr="airLineId"
                    onSelectionChanged={onAirlineReturnChange}
                    showClearButton={true}
                    searchEnabled={true}
                  />
                  {errors.airlineIdReturn.length > 0 && <span className="rx-err">{errors.airlineIdReturn}</span>}
                </div>
                <div className="rx-fg">
                  <label>Flight # <span className="req">*</span></label>
                  <input type="text" className="rx-ff" maxLength={25} value={state.flightNumberReturn} onChange={onChange} name="flightNumberReturn" placeholder="Flight #" />
                  {errors.flightNumberReturn.length > 0 && <span className="rx-err">{errors.flightNumberReturn}</span>}
                </div>
              </div>
              <div className="rx-cols-2">
                <div className="rx-fg">
                  <label>Terminal Type</label>
                  <select className="rx-ff" name="terminalTypeReturn" value={state.terminalTypeReturn} onChange={onChange}>
                    <option value="0">Select terminal type</option>
                    {terminalTypeData && terminalTypeData.map((item, i) => (
                      <option key={i} value={item.id}>{item.name}</option>
                    ))}
                  </select>
                  {errors.terminalTypeReturn.length > 0 && <span className="rx-err">{errors.terminalTypeReturn}</span>}
                </div>
                <div className="rx-fg">
                  <label>Terminal</label>
                  <input type="text" className="rx-ff" maxLength={25} value={state.terminalReturn} onChange={onChange} name="terminalReturn" placeholder="Terminal" />
                </div>
              </div>
              <div className="rx-cols-3">
                <div className="rx-fg">
                  <label>Pilot <span className="req">*</span></label>
                  <NumericInput className="form-control form-control-sm" name="pilotCountReturn" title="Pilot Count" value={state.pilotCountReturn} min={0} max={100} onChange={(value) => onPaxCountReturnChange('p', value)} />
                  {errors.pilotCountReturn.length > 0 && <span className="rx-err">{errors.pilotCountReturn}</span>}
                </div>
                <div className="rx-fg">
                  <label>Crew <span className="req">*</span></label>
                  <NumericInput className="form-control form-control-sm" name="crewCountReturn" title="Crew Count" value={state.crewCountReturn} min={0} max={100} onChange={(value) => onPaxCountReturnChange('c', value)} />
                </div>
                <div className="rx-fg">
                  <label>F/A <span className="req">*</span></label>
                  <NumericInput className="form-control form-control-sm" name="flightAttandCountReturn" title="Flight Attendant Count" value={state.flightAttandCountReturn} min={0} max={100} onChange={(value) => onPaxCountReturnChange('f', value)} />
                </div>
              </div>
              <div className="rx-cols-2">
                <div className="rx-fg">
                  <label>Flight Time [ hh ] <span className="req">*</span></label>
                  <SelectBox
                    dataSource={state.dropdownHours.length > 0 ? state.dropdownHours : []}
                    placeholder="Select Hour"
                    name="id"
                    defaultValue={0}
                    value={state.flightHourReturn}
                    displayExpr="name"
                    valueExpr="id"
                    onSelectionChanged={onFlightHourReturnChange}
                    showClearButton={true}
                    searchEnabled={true}
                  />
                  {errors.flightTimeReturn.length > 0 && <span className="rx-err">{errors.flightTimeReturn}</span>}
                </div>
                <div className="rx-fg">
                  <label>[ min ]</label>
                  <SelectBox
                    dataSource={state.dropdownMinutes.length > 0 ? state.dropdownMinutes : []}
                    placeholder="Select Minute"
                    name="id"
                    defaultValue={0}
                    value={state.flightMinuteReturn}
                    displayExpr="name"
                    valueExpr="id"
                    onSelectionChanged={onFlightMinuteReturnChange}
                    showClearButton={true}
                    searchEnabled={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default AirlineDetailsCard;
